import type { InputKind } from '../engine/types';
import { inputManager, type InputSelection } from '../input/manager';
import { settingsStore, type Settings } from '../store/settings';

export function selectionFromSettings(s: Settings): InputSelection {
  switch (s.inputKind) {
    case 'midi':
      return { kind: 'midi', deviceId: s.midiDeviceId };
    case 'mic':
      return { kind: 'mic', deviceId: s.micDeviceId, latencyMs: s.micLatencyMs };
    case 'synth':
      return { kind: 'synth', latencyMs: s.micLatencyMs };
    default:
      return { kind: 'keyboard' };
  }
}

/** Active la source choisie (à appeler depuis un geste de l'utilisateur : clic ou touche). */
export async function activateInput(kind?: InputKind): Promise<void> {
  if (kind) settingsStore.set({ inputKind: kind });
  await inputManager.select(selectionFromSettings(settingsStore.get()));
}

export const INPUT_LABELS: Record<InputKind, string> = {
  mic: 'Micro',
  midi: 'MIDI',
  keyboard: 'Clavier d’essai',
  synth: 'Synthèse (test)',
};
